module.exports = __webpack_public_path__ + "static/9-25313eb9b2c6aa74d7f0876d9400b283.png";